import React from 'react';
import Icon from '../atoms/Icon';

function StarBadgeIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <g
        fill='currentColor'
        fillRule='nonzero'
      >
        <path d="M29.5385 16C29.5385 8.55666 23.4433 2.46154 16 2.46154C8.55666 2.46154 2.46154 8.55666 2.46154 16C2.46154 23.4433 8.55666 29.5385 16 29.5385C23.4433 29.5385 29.5385 23.4433 29.5385 16ZM32 16C32 24.8028 24.8028 32 16 32C7.19719 32 0 24.8028 0 16C0 7.19719 7.19719 0 16 0C24.8028 0 32 7.19719 32 16Z"/>
        <path d="M24.6154 16C24.6154 11.2643 20.7356 7.3846 16 7.3846C11.2643 7.3846 7.3846 11.2643 7.3846 16C7.3846 20.7356 11.2643 24.6154 16 24.6154C20.7356 24.6154 24.6154 20.7356 24.6154 16ZM27.0769 16C27.0769 22.0951 22.0951 27.0769 16 27.0769C9.90487 27.0769 4.92307 22.0951 4.92307 16C4.92307 9.90487 9.90487 4.92307 16 4.92307C22.0951 4.92307 27.0769 9.90487 27.0769 16Z"/>
        <path d="M16 9.84616C12.5539 9.84616 9.84616 12.5539 9.84616 16C9.84616 19.4462 12.5539 22.1539 16 22.1539C19.4462 22.1539 22.1539 19.4462 22.1539 16C22.1539 12.5539 19.4462 9.84616 16 9.84616ZM19.0769 20.0615L16 17.8462L13.0462 20.0615L14.2769 16.3692L11.3231 14.0308H15.0154L16.1231 10.7077L17.3539 14.0308H20.9231L17.9692 16.3692L19.0769 20.0615Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(StarBadgeIcon);
